import Stack from '@mui/material/Stack';
import { type StackProps, Typography, useTheme } from '@mui/material';
import { getGamesWrapperSx, getGameWrapperSx } from './styles.ts';

const tempGameValues = [
  { title: 'Ball speed', value: '', unit_of_measurement: 'mph' },
  { title: 'Club speed', value: '', unit_of_measurement: 'mph' },
  { title: 'Launch angle', value: '', unit_of_measurement: 'deg' },
  { title: 'Launch dir.', value: '', unit_of_measurement: 'deg' },
  { title: 'Back spin', value: '', unit_of_measurement: 'rpm' },
  { title: 'Side spin', value: '', unit_of_measurement: 'rpm' },
];

export const GameParams = (props: StackProps) => {
  const theme = useTheme();
  return (
    <Stack direction={'row'} flexWrap={'wrap'} {...props}>
      {tempGameValues.map(el => (
        <Stack key={el.title} sx={getGamesWrapperSx(theme)}>
          <Typography variant={'body'} sx={{ p: 4 }}>{el.title}</Typography>
          <Stack sx={getGameWrapperSx(theme)}>
            <Typography variant={'title'}>{el.value || '-'}</Typography>
            <Typography variant={'description'}>{el.unit_of_measurement}</Typography>
          </Stack>
        </Stack>

      ))}
    </Stack>
  );
};
